// src/pages/.../lessonPlan/RejectedLessonPlan.js
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useSelector } from "react-redux";
import styles from "../../../../../src/pages/schoolCockpit/master/academicConfiguration/Academiclist.module.css";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import CustomToggle from "../../../../components/CustomToggle/CustomToggle";
import { TokenService } from "../../../../services/Api";
import useLessonPlanData from "./useLessonPlanData";
import { buildLessonPlanColumns } from "./lessonPlanColumns";
import LessonPlanHistoryPanel from "./LessonPlanHistoryPanel";

function RejectedLessonPlan() {
  const navigate = useNavigate();
  const { translations } = useSelector((state) => state.language);
  const user = TokenService.getUser();
  const roleId = Number(user?.role?.id);
  const hideActions = [4, 6].includes(roleId);

  // initial toggle = "all" (per requirement)
  const [weekFilter, setWeekFilter] = useState("all");

  const {
    data,
    loading,
    rowCount,
    pagination,
    setPagination,
    columnFilters,
    handleColumnFiltersChange,
    topicOptions,
    subTopicOptions,
  } = useLessonPlanData(3, weekFilter === "this_week" ? 1 : 0);

  const handleView = (row) => {
    navigate("/user/lessonplanview", {
      state: { ID: row.def_id, data: row },
    });
  };

  const handleDateRangePicked = () => {
    if (weekFilter !== "all") setWeekFilter("all");
  };

  const toggleOptions = [
    { label: translations?.labels?.toggleAll || "All", value: "all" },
    {
      label: translations?.labels?.toggleThisWeek || "This week",
      value: "this_week",
    },
  ];

  const columns = useMemo(() => {
    const cols = buildLessonPlanColumns({
      translations,
      topicOptions,
      subTopicOptions,
      includeTopic: false, // 👈 hide Topic
      includeSubTopic: false,
      includePeriod: true,
      includeDay: true,
      includeSection: true,
      includeScheduledDate: true,
      includeStatus: false, // rejected tab: status column hidden
      onDateRangePicked: handleDateRangePicked,
    });

    if (!hideActions) {
      cols.push({
        id: "actions",
        header: translations?.labels?.action || "Action",
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <button
            className={styles.viewBtn}
            onClick={() => handleView(row.original)}
            title={translations?.labels?.view || "View"}
          >
            <FaEye />
          </button>
        ),
      });
    }
    return cols;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translations, topicOptions, subTopicOptions, hideActions, weekFilter]);

  return (
    <>
      <div className={styles.toggleRow}>
        <CustomToggle
          options={toggleOptions}
          value={weekFilter}
          onChange={setWeekFilter}
        />
      </div>

      <CustomMRTTable
        columns={columns}
        data={data}
        loading={loading}
        pagination={pagination}
        rowCount={rowCount}
        onPaginationChange={setPagination}
        columnFilters={columnFilters}
        onColumnFiltersChange={handleColumnFiltersChange}
        enableColumnFilters={true}
        enableGlobalFilter={false}
        hideGlobalSearch={true}
        enableExpanding={true}
        renderDetailPanel={({ row }) => <LessonPlanHistoryPanel row={row} />}
      />
    </>
  );
}

export default RejectedLessonPlan;
